import Vue from 'vue';
import VueTouch from 'vue-touch';
import { library } from '@fortawesome/fontawesome-svg-core';
import VTooltip from 'v-tooltip';

import {
  faCheckCircle,
  faChevronDown,
  faCaretUp,
  faCaretDown,
  faChevronUp,
  faExternalLinkAlt,
  faInfoCircle,
  faChevronLeft,
  faChevronRight,
  faTimes,
  faBars,
  faSearch,
  faTimesCircle,
  faGlobeAsia,
  faCheckSquare,
  faMinusSquare,
  faAngleDoubleLeft,
  faEye,
  faTachometerAlt,
  faServer,
  faAddressCard,
  faDatabase,
  faGlobe,
  faFileMedicalAlt,
  faWindowRestore,
  faTools,
  faBalanceScale,
  faEllipsisV,
  faUserCircle,
} from '@fortawesome/free-solid-svg-icons';

import { faCheckCircle as faCheckCircleO } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import App from './App.vue';
import router from './router';
import store from './store/store';
import i18n from './i18n';

// import 'bootstrap/dist/css/bootstrap.css'; // add this back if you need the original bootstrap
import 'bootstrap/dist/js/bootstrap';
import '../node_modules/@webops/web-framework-theme/dist/css/theme-app.min.css';
import '../node_modules/@webops/web-framework-theme/dist/js/theme.min';
import './config/ripe';
import './styles/widgets.css';

library.add(
  faCheckCircle,
  faCheckCircleO,
  faChevronDown, //
  faChevronUp,
  faChevronLeft, //
  faChevronRight, //
  faSearch, //
  faTimesCircle, //
  faCaretDown,
  faCaretUp,
  faExternalLinkAlt,
  faInfoCircle,
  faTimes,
  faBars, //
  faGlobeAsia, //
  faCheckSquare, //
  faMinusSquare, //
  faInfoCircle,
  faAngleDoubleLeft,
  faEye,
  faTachometerAlt,
  faServer,
  faAddressCard,
  faDatabase,
  faGlobe,
  faFileMedicalAlt,
  faWindowRestore,
  faTools,
  faBalanceScale,
  faEllipsisV,
  faUserCircle
);

Vue.component('fa', FontAwesomeIcon);

Vue.config.productionTip = false;
Vue.use(VueTouch, { name: 'v-touch' });
Vue.use(VTooltip);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
